import type { AnyRouter } from '@tanstack/react-router';

/** A page with a second route: `from`, the route links point at, and `to`, which takes the same params. */
export type MovedPage = { from: string; to: string };

const movedPagesByRouter = new WeakMap<AnyRouter, ReadonlyArray<MovedPage>>();

/** Internal: what `createAppRouter` was given, for `useRouteName`, `useIsRouteActive` and `useNavigate`. */
export function setMovedPages(router: AnyRouter, pages: ReadonlyArray<MovedPage>): void {
    movedPagesByRouter.set(router, pages);
}

export function movedPagesOf(router: AnyRouter): ReadonlyArray<MovedPage> {
    return movedPagesByRouter.get(router) ?? [];
}
